import { createCRUDHook } from './createCRUDHook';
import {
  RackBinDto,
  RackBinSearchParams,
  SearchRackBinResponse,
} from 'utils/models';
import { TBL_RACK_BIN, TBL_RACK_BIN_SEARCH } from './apiEndPoints';
import { prepareQueryParams } from 'utils';

interface RackBinCustomOperations {
  SearchRackBinData: (
    filteredEntities: RackBinSearchParams
  ) => Promise<SearchRackBinResponse>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  RackBinDto,
  RackBinDto[],
  RackBinCustomOperations
>({
  entityName: 'RackBin',
  endpoint: TBL_RACK_BIN,

  customOperations: (auth) => ({
    SearchRackBinData: async (
      filteredEntities: RackBinSearchParams
    ): Promise<SearchRackBinResponse> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TBL_RACK_BIN +
            TBL_RACK_BIN_SEARCH +
            `?${prepareQueryParams(filteredEntities)}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const RackBinContext = Context;
export const useRackBinManager = useManager;
export const useRackBin = useConsumer;
